const favourite_animal  = `Yksi suosikkieläimistäni on poro.
Ne elävät kylmissä paikoissa, kuten Suomessa, ja niillä on erityispiirteitä, jotka auttavat heitä selviytymään lumessa.
Poroilla on paksu turkki, joka pitää ne lämpimänä talvella.
Heillä on myös leveät kaviot, jotka auttavat heitä kävelemään lumella uppoamatta.
Näin heidän on helpompi löytää ruokaa, kuten kasveja ja sammalta, vaikka ulkona sataa lunta.
Porot tunnetaan suurista sarvistaan, joilla ne puolustavat itseään ja etsivät ruokaa.
Nämä sarvet voivat myös olla erilaisia miehillä ja naisilla.
Ne ovat vahvoja ja voivat auttaa poroja kaivamaan lumen läpi löytääkseen ruokaa talvella.
Joissain paikoissa ihmiset käyttävät poroja kelkkojen vetämiseen ja raskaiden tavaroiden kantamiseen.
Porot ovat tärkeitä joillekin kulttuureille ja ovat olleet osa heidän elämäänsä jo pitkään.
Kaiken kaikkiaan porot ovat uskomattomia eläimiä, jotka selviävät kylmissä paikoissa, kuten Suomessa.
Ne ovat vahvoja ja niillä on erityispiirteitä, jotka auttavat heitä elämään lumessa.
Ne ovat myös tärkeitä joillekin kulttuureille ja niillä on erityinen paikka heidän sydämessään`;

export default favourite_animal;